module.exports = __webpack_public_path__ + "static/media/loc6_img8.a9ffd080.jpg";